// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Zt-z","tooltipWrapper":"_t-z","icon":"au-z","tooltip":"bu-z","content":"cu-z"};